import { defineRelease } from '../types'

export default defineRelease({
  version: '2026.11.2',
  date: '2026-11-03',
  summary: 'Dates in your own time zone.',
  entries: [
    {
      id: 'personal-time-zone',
      type: 'new',
      module: 'general',
      title: 'See dates in your time zone',
      body: 'Choose your time zone and date format in Settings → Preferences, or keep your organisation’s. Due dates now show the time too, and a date you pick is due at the end of that day where you are.',
      link: { to: '/settings?tab=preferences', label: 'Open Preferences' },
    },
    {
      id: 'organisation-time-zone',
      type: 'improved',
      module: 'admin',
      title: 'Change your organisation’s time zone',
      body: 'Set it in Organization Hub. It drives SLAs, business hours and the dates in notification emails, which now read like “3 Nov 2026, 02:00 IST” instead of UTC.',
      link: { to: '/admin/organization', label: 'Open Organization Hub' },
      roles: ['iam_org_admin', 'iam_superadmin'],
    },
  ],
})
